import React, { useState } from 'react'
import { TextField, Toolbar, Typography, Button } from '@mui/material';
import AddUpdateUnitDialog from 'app/components/Dialog/AddUpdateUnitDialog';
import { useSelector } from 'react-redux';
import { isRoleCheckList } from 'app/utils/appHelpers';

function UnitDataTableToolbar({ pageTitle, data2, setData, afterUpdateFunc, addAfterTable, type, setHighlightQuery }) {
    const { authUser } = useSelector(state => state.auth);

    const [searchText, setSearchText] = useState("");
    const [addUnitDialogStatus, setAddUnitDialogStatus] = useState(false);

    const handleChangeSearchText = (text) => {
        if (text !== "") {
            const filterData = data2.filter(
                (item) =>
                    item.inst.toLocaleLowerCase().includes(text.toLocaleLowerCase()) ||
                    item.name.toLocaleLowerCase().includes(text.toLocaleLowerCase()) ||
                    item.id === Number(text)
            );

            setSearchText(text);
            setHighlightQuery(text);
            setData(filterData);
        } else {
            setSearchText(text);
            setHighlightQuery(text);
            setData(data2);
        }
    };

    return (
        <Toolbar className="table-header row" sx={{ justifyContent: 'space-between', background: '#e1e1e1' }}>
            <div className="title">
                <Typography variant="title" sx={{  }}>{pageTitle}</Typography>
            </div>

            <div>

                {
                    type === undefined && isRoleCheckList(authUser.userRoles, [1, 373, 370]) && (
                        <Button
                            variant="contained"
                            sx={{ marginTop: '14px', marginRight: '10px' }}
                            size="large"
                            onClick={() => setAddUnitDialogStatus(true)}
                        >
                            Kurul/Kol/Komisyon Ekle
                        </Button>
                    )
                }

                <TextField
                    id="searchText1xe"
                    value={searchText}
                    onChange={(e) => handleChangeSearchText(e.target.value)}
                    margin="dense"
                    label={"Arama Yap"}
                    className="mr-4"
                    // autoFocus
                    style={{ width: "400px", background: 'white' }}
                    placeholder={'Bilgi'}
                    InputProps={{
                        style: {  }
                    }}
                    InputLabelProps={{
                        style: {  }
                    }}
                />
            </div>

            {
                type === undefined ?
                    <AddUpdateUnitDialog open={addUnitDialogStatus} onClose={() => setAddUnitDialogStatus(false)} afterUpdateFunc={afterUpdateFunc} addAfterTable={addAfterTable} /> : null

            }

        </Toolbar>
    );
};

export default UnitDataTableToolbar